import { useState, useEffect, useContext, useRef } from 'react';

import { LiveReserveContext } from '../../../../../LiveLessonReseveContext';
import LiveReserveSituationCaseCategoryBusiness from './business/LiveReserveSituationCaseCategoryBusiness';
import LiveReserveSituationCaseCategoryLine from './line/LiveReserveSituationCaseCategoryLine';

import { LiveReserveSituationValue } from '../../../../../../../../../models/lesson/live/reserve/situation/LiveReserveSituation';
import { LiveReserveSituationType } from '../../../../../../../../../models/lesson/live/reserve/situation/type/LiveReserveSituationType';


// シチュエーションごと
function LiveReserveSituationCaseCategory(props: any) {

  const type: LiveReserveSituationType = props.type;

  const {
    config, user, title,
  } = useContext(LiveReserveContext);

  const category: string = props.category;
  const lineList: LiveReserveSituationValue = props.lineList;
  const label: string = props.label;

  const openCateKey = props.openCateKey;
  const setOpenCateKey = props.setOpenCateKey;
  const cateRef = props.cateRef;

  const [isDisp, setIsDisp] = useState<boolean>(false);
  const [isBusiness, setIsBusiness] = useState(false);


  // 表示判定
  useEffect(() => {
    const groupId = type?.groupId;
    if(groupId) {
      setIsDisp(
        category !== '97' &&
        config.live_lesson_practice_category_group[groupId].includes(Number(category))
      );
    }
  }, [type, category])


  // ビジネス判定
  useEffect(() => {
    setIsBusiness(
      Boolean(title) &&
      Number(category) === 2 &&
      !user.course_biz
    );
  }, [category])


  const chgOpenCate = () => {
    if(openCateKey == category) {
      // 開いている場合→閉じる
      setOpenCateKey('');
    } else {
      // 閉じている場合→開く
      setOpenCateKey(category);
    }
  }


  return (
    <>
    {isDisp &&
      <div ref={cateRef} key={category}>

        <div
          className="list-group-item list-group-item-warning"
          style={{ cursor: 'pointer' }}
          onClick={chgOpenCate}
        >
          <strong>
            {label}
            {Number(category) === 1 && ` ${user.course_name}`}
          </strong>
          <span className="glyphicon glyphicon-chevron-down pull-right"></span>
        </div>

        {openCateKey == category &&
          <div id={`situation_${category}`}>
            <ul className="list-group" style={{ marginBottom: '2px' }}>

              {/* ビジネスコース */}
              {isBusiness &&
                <LiveReserveSituationCaseCategoryBusiness
                  category={category}
                />
              }

              {/* シチュエーション選択行 */}
              {lineList &&
                Object.entries(lineList).map(([key, info]) => (
                  <LiveReserveSituationCaseCategoryLine
                    key={key}
                    category={category}
                    info={info}
                    isBusiness={isBusiness}
                  />
                ))
              }

            </ul>
          </div>
        }

      </div>
    }
    </>
  );
}
  
export default LiveReserveSituationCaseCategory;